import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emailSettingAccountSynced" }
const _hoisted_2 = { class: "emailSettingAccountSynced__items" }
const _hoisted_3 = { class: "emailSettingAccountSynced__title" }
const _hoisted_4 = { class: "emailSettingAccountSynced__email" }
const _hoisted_5 = { class: "emailSettingAccountSynced__status" }
const _hoisted_6 = { class: "emailSettingAccountSynced__title" }
const _hoisted_7 = { class: "emailSettingAccountSynced__buttons" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { CompassEnums } from '@sellsy/compass2';
import emailStatuses from 'Dictionaries/emailStatuses';

interface Props {
    status?: string;
    email?: string;
    isEmailsSentFromCorp: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailSettingAccountSynced',
  props: {
    status: { default: '' },
    email: { default: '' },
    isEmailsSentFromCorp: { type: Boolean }
  },
  emits: ["updateEmailStatus", "handleDisplayDialog"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const isAdmin = computed(() => store.state.user.isAdmin);
const showDisconnectButton = computed(() => isAdmin.value || !props.isEmailsSentFromCorp);
const syncStatus = computed(() => {
    return emailStatuses[props.status as keyof typeof emailStatuses] || emailStatuses.default;
});

return (_ctx: any,_cache: any) => {
  const _component_CompassTag = _resolveComponent("CompassTag")!
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t.__('email.EmailSettingAccountSynced.syncEmail')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.email), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t.__('email.EmailSettingAccountSynced.connectionStatus')), 1 /* TEXT */),
        _createVNode(_component_CompassTag, {
          color: syncStatus.value.color
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(syncStatus.value.message), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["color"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (showDisconnectButton.value)
        ? (_openBlock(), _createBlock(_component_CompassButton, {
            key: 0,
            label: _ctx.$t.__('email.disconnect_my_email'),
            type: _unref(CompassEnums).ButtonType.TERTIARY_DESTRUCTIVE,
            size: _unref(CompassEnums).ButtonSize.MEDIUM,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleDisplayDialog')))
          }, null, 8 /* PROPS */, ["label", "type", "size"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_CompassButton, {
        label: _ctx.$t.__('email.EmailSettingAccountSynced.update'),
        type: _unref(CompassEnums).ButtonType.SECONDARY,
        leftIcon: "sync",
        size: _unref(CompassEnums).ButtonSize.MEDIUM,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('updateEmailStatus')))
      }, null, 8 /* PROPS */, ["label", "type", "size"])
    ])
  ]))
}
}

})